import React from 'react';
import MetaTags from 'react-meta-tags';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './HomeHeaderCreatorsAlternate.scss';

import { openAuthModal } from '../../../Actions/UIActions';
import usePageLoadEvent from '../../../CustomHooks/usePageLoadEvent';
import ScrollToTop from '../../General/ScrollToTop';

const CREATOR_HEADER_CONTENT = {
  1: {
    titleLine1: 'Affiliate,',
    titleLine2: 'without the extra work',
    description: 'Easily create a beautiful, customizable storefront for your favorite product recommendations.',
    actionText: 'Apply to Join',
  },
  2: {
    titleLine1: 'Build your business,',
    titleLine2: 'not just your following',
    description: 'Turn your story views into earnings.',
    actionText: 'Start Earning',
  }
}

const HomeHeaderCreatorsAlternate = props => {
  const { headerContentKey } = props;
  const seo_title = 'ShopMy | Monetize Your Influence';
  const seo_description = 'Enable your audience to shop your product recommendations while building meaningful partnerships with world-class brands.';

  usePageLoadEvent('Home - Creators - Page View', { version: headerContentKey });

  return (
    <div className='home-header-creators-alternate-outer-container'>
      <MetaTags>
        <title>{seo_title}</title>
        <meta property='og:title' content={seo_title} />
        <meta property='description' content={seo_description} />
        <meta property='og:description' content={seo_description} />
        <meta property='og:image' content='https://static.shopmy.us/social-share-banner.png' />
      </MetaTags>
      <ScrollToTop />
      <div className='home-header-creators-alternate-inner-container'>
        <div className='spacer' />
        <div className='main-container'>
          <div className='title-section'>
            <h1 className='title'>
              {CREATOR_HEADER_CONTENT[headerContentKey].titleLine1}
              <br />
              {CREATOR_HEADER_CONTENT[headerContentKey].titleLine2}
            </h1>
            <h2 className='subtitle'>{CREATOR_HEADER_CONTENT[headerContentKey].description}</h2>
            <div className='actions'>
              <Link to='/apply/creator' className='action primary'>
                {CREATOR_HEADER_CONTENT[headerContentKey].actionText}
              </Link>
            </div>
          </div>
          <div className='image-section'>
            <img src='https://static.shopmy.us/Home/Creators/creator-image-stack.png' alt='ShopMy Creator Preview' />
          </div>
        </div>
      </div>
    </div>
  );
};

HomeHeaderCreatorsAlternate.propTypes = {
  user: PropTypes.object.isRequired,
  openAuthModal: PropTypes.func.isRequired,
  headerContentKey: PropTypes.number.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  openAuthModal
})(HomeHeaderCreatorsAlternate);
